import { authentication_reducer } from "./AuthenticationReducer";

export default authentication_reducer;